import { customAmplitude } from '@/utils/customAmplitude'
import { displayConfetti } from '@/utils/confettiAnimation'
import { SHOW_DOWNLOAD_APP_TIME_DURATION, ShowModalType } from '@/scenes/engine/common/constants'
import useModal from './useModal'

/**
 * Returns a callback that triggers the post-download confetti animation and
 * "Download App" modal prompt — but only the first time the user downloads.
 */
export function useDownloadConfetti(): () => void {
  const { setShowModalType } = useModal()

  return () => {
    if (localStorage.getItem('isDisplayedModalDownloadApp')) return
    customAmplitude('Get App Modal', { Source: '1st time' })
    displayConfetti()
    setTimeout(() => setShowModalType(ShowModalType.DOWNLOAD_APP), SHOW_DOWNLOAD_APP_TIME_DURATION)
  }
}
